import React, { useContext, useState } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import useFetchExtendedDeviation from '../../useExtendedDeviation';
import BoostNoCoreModal from '../BoostNoCoreModal';
import BoostUpgradeCoreModal from '../BoostUpgradeCoreModal';
import BoostModal from '../BoostModal';
import BoostSuccessModal from '../BoostSuccessModal';
import AlreadyBoostedModal from '../AlreadyBoostedModal';
const BoostRootModal = ({ deviation: deviationFromProps, onRequestClose })=>{
    var _deviation_extended;
    const { hasCoreMembership, coreLevel } = useContext(SessionContext);
    const deviation = useFetchExtendedDeviation(deviationFromProps);
    let initialModal = 'boost';
    if (!hasCoreMembership) {
        initialModal = 'no-core';
    } else if (coreLevel === 'core_access') {
        initialModal = 'upgrade-core';
    } else {
        if (!deviation.extended) {
            initialModal = 'loading';
        }
    }
    if ((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.boosted) {
        initialModal = 'already-boosted';
    }
    const [showingModal, setShowingModal] = useState(initialModal);
    const showSuccessModal = ()=>setShowingModal('success');
    return /*#__PURE__*/ React.createElement(React.Fragment, null, showingModal === 'loading' && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        view: "llama",
        usePortal: true,
        withOverlay: true
    }), showingModal === 'no-core' && /*#__PURE__*/ React.createElement(BoostNoCoreModal, {
        onRequestClose: onRequestClose
    }), showingModal === 'upgrade-core' && /*#__PURE__*/ React.createElement(BoostUpgradeCoreModal, {
        onRequestClose: onRequestClose
    }), showingModal === 'boost' && /*#__PURE__*/ React.createElement(BoostModal, {
        deviation: deviation,
        onSuccess: showSuccessModal,
        onRequestClose: onRequestClose
    }), showingModal === 'success' && /*#__PURE__*/ React.createElement(BoostSuccessModal, {
        onRequestClose: onRequestClose
    }), showingModal === 'already-boosted' && /*#__PURE__*/ React.createElement(AlreadyBoostedModal, {
        onRequestClose: onRequestClose
    }));
};
BoostRootModal.displayName = 'BoostRootModal';
export default BoostRootModal;

//# sourceMappingURL=BoostRootModal.js.map